import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/eventTimeZone/importer/eventTimeZoneImporterSelectors';
import EventTimeZoneService from 'src/modules/eventTimeZone/eventTimeZoneService';
import fields from 'src/modules/eventTimeZone/importer/eventTimeZoneImporterFields';
import { i18n } from 'src/i18n';

const eventTimeZoneImporterActions = importerActions(
  'EVENTTIMEZONE_IMPORTER',
  selectors,
  EventTimeZoneService.import,
  fields,
  i18n('entities.eventTimeZone.importer.fileName'),
);

export default eventTimeZoneImporterActions;